var map = {
	"./condiciones.jpg": "PmVc",
	"./contrato.jpg": "2W05",
	"./documentacion.jpg": "apeW",
	"./kyc.jpg": "Dc/v",
	"./pago.jpg": "VXl9",
	"./pbc.jpg": "jg64",
	"./validacionDocumentacion.jpg": "6YCy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ReKl";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reserva ^\.\/.*\.jpg$
// module id = ReKl
// module chunks = 1